module.exports = __webpack_public_path__ + "img/theme-light.9a9a1864.svg";